import React from 'react';
import injectSheet from 'react-jss';
import RadioButton from 'Components/RadioButton';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 } from 'uuid';
import styleSheet from './styles';

interface Props {
  // eslint-disable-next-line react/no-unused-prop-types
  direction?: 'row' | 'column';
  // eslint-disable-next-line react/no-unused-prop-types
  justify?: string;
  selectedValue?: string;
  field: any;
  classes?: any;
  onChange?: (e: object) => void;
}

const RadioButtonList: React.FC<Props> = (props: Props) => {
  const { selectedValue, field, classes, onChange } = props;

  return (
    <div
      role="radiogroup"
      className={classes.radioList}
      data-testid="radioButtonList"
    >
      {field.list.map((item: any) => {
        return (
          <div className="radioHolder" key={v4()}>
            <RadioButton
              isChecked={selectedValue === item.value}
              onClick={onChange}
              id={item.id}
              value={item.value}
            >
              <label
                className={classes.label}
                key={v4()}
                active-color="#085FE5"
                htmlFor={item.id}
              >
                {item.label}
              </label>
            </RadioButton>
          </div>
        );
      })}
    </div>
  );
};

RadioButtonList.defaultProps = {
  direction: undefined,
  justify: undefined,
  selectedValue: undefined,
  classes: {},
  onChange: () => {},
};

export default injectSheet(styleSheet)(RadioButtonList);
